import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { denormalizeNumber, normalizeNumber, NumberFormatter } from '@utils'

interface Props {
  minimumRange: number
  normalizedRanges: [number, number]
}

/**
 * Componente che disegna un asse x per i grafici RPE
 * @param minimumRange {number}
 * @param normalizedRanges {number[]}
 * @component
 */
export const Axis: React.FC<Props> = ({ minimumRange, normalizedRanges }) => {
  //region axisPoint
  const [axisValues, setAxisValues] = useState<string[]>([])
  useEffect(() => {
    const min = normalizedRanges[0]
    const max = normalizedRanges[1]
    const gap = (max - min) / 6
    const axisPoint = []

    for (let i = 0; i <= 6; i++) {
      const normalizedValue = denormalizeNumber(min + gap * i, minimumRange)
      axisPoint.push(`${NumberFormatter(normalizedValue, 'KGM')}`)
    }
    setAxisValues(axisPoint)
  }, [minimumRange, normalizedRanges])
  //endregion

  return (
    <Container data-cy={'x-axis'}>
      <AxesRow />
      <PointerContainer>
        {axisValues.map((_, index) => (
          <AxesPointer
            position={index === 0 ? 'start' : index === 6 ? 'end' : undefined}
            key={`pointer-${index}`}
          />
        ))}
      </PointerContainer>
      <AxisValues>
        {axisValues.map((point, index) => (
          <AxisValue
            position={index === 0 ? 'start' : index === 6 ? 'end' : undefined}
            key={`value-${index}`}
          >
            {point}
          </AxisValue>
        ))}
      </AxisValues>
    </Container>
  )
}

//region Style
const Container = styled.div`
  display: grid;
  grid-template-rows: 10px 4px auto;
  margin-left: 80px;
  margin-right: 40px;
`
const AxisValues = styled.div`
  display: grid;
  grid-template-columns: 0.65fr 1fr 1fr 1fr 1fr 1fr 0.65fr;
`
const AxisValue = styled.div<{ position?: string }>`
  font-size: 10px;
  font-weight: 400;
  place-self: ${({ position }) => position || 'center'};
`

const AxesRow = styled.div`
  margin: 0 10px;
  border-bottom: 1px solid #ffffff;
`
const PointerContainer = styled.div`
  margin: 0 10px;
  display: grid;
  grid-template-columns: 0.65fr 1fr 1fr 1fr 1fr 1fr 0.65fr;
`
const AxesPointer = styled.div<{ position?: string }>`
  place-self: ${({ position }) => position || 'center'};
  width: 1px;
  height: 100%;
  border-right: 1px solid #ffffff;
`
//endregion
